export enum ServiceCountriesEnum {
    FR = 'FR',
    CY = 'CY',
}
